
import { z } from "zod";

export const PhoneCallDirectionValues = ["INCOMING", "OUTGOING"] as const;
export const PhoneCallDirectionSchema = /* @__PURE__ */ z.enum(PhoneCallDirectionValues);
export const PhoneCallDirection: (typeof PhoneCallDirectionSchema)["enum"] = { "INCOMING": "INCOMING", "OUTGOING": "OUTGOING" };
export type PhoneCallDirection = (typeof PhoneCallDirectionValues)[number];
export const PhoneCallDirectionDisplayNames = { "INCOMING": "Incoming",
"OUTGOING": "Outgoing", } satisfies Record<PhoneCallDirection, string>;
